import React, { useState } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import type { ITheme } from '@homeviews/styles'
import { MediaCore, RequestMediaForm } from '@homeviews/media'
import {
  Typography,
  PreviewDrawer,
  Button,
  WindowTitle,
} from '@homeviews/shared-ui'
import { mixpanelTrack } from '@homeviews/seo'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
    header: {
      display: 'flex',
    },
    title: {
      marginRight: 10,
    },
    requestButtonWrapper: {},
  }),
)
const Resources: React.FC = () => {
  const classes = useStyles()
  const [requestMediaFormOpened, setRequestMediaFormOpened] = useState(false)
  return (
    <>
      <WindowTitle title="Resources" />
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography variant="h1" className={classes.title}>
            Your HomeViews Resources
          </Typography>
          <div className={classes.requestButtonWrapper}>
            <Button
              variant="outlined"
              customVariant="outlinedPrimary"
              fullWidth
              onClick={() => {
                mixpanelTrack('RESOURCES_ADD_NEW_MEDIA')
                setRequestMediaFormOpened(true)
              }}
            >
              Request new media
            </Button>
          </div>
        </div>
        <MediaCore
          libraryType="resources"
          header="Files"
          formats="docx,gif,jpg,mp4,pdf,png,pptx,svg,zip"
          defaultView="table"
          disabledCardsView
        />
        {
          <PreviewDrawer
            open={requestMediaFormOpened}
            onClose={() => {
              setRequestMediaFormOpened(false)
            }}
            hideNav
          >
            <RequestMediaForm
              onClose={() => {
                setRequestMediaFormOpened(false)
              }}
            />
          </PreviewDrawer>
        }
      </div>
    </>
  )
}

export default Resources
